import React, { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { GetApplicationInformation } from "../../../Redux/Reducers/Shared/ApplicationInformation";
import { decryptToken } from "../../../Services/Encryption/EncryptionParams";
import moment from "moment-timezone";

const ApplicationInfo = (porps) => {
  const renderData=useSelector((state)=>state.ApplicationInformationReducers.ChangeApplicationStatus)
  const AppGuid = useParams();
  const [appInfo, setAppInfo] = useState();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      FetchDataJson: state.FetchDataJson,
      ApplicationInformation: state.ApplicationInformationReducers,
    };
  });
  console.log(
    state.ApplicationInformation,
    "ApplicationInformationddddddddddd"
  );
  const getData = async () => {
    const data = await dispatch(
      GetApplicationInformation({
        applicationInformationId:
          localStorage.getItem("ApplicationInformationId") ||
          porps.applicationGuid,
      })
    );

    if (data.payload) {
      setAppInfo({ ...data.payload });
    }
  };
  useEffect(() => {
    getData();
  }, [renderData]);
  console.log(appInfo, "appInfo");

  return (
    <>
      <div className="form-grid">
        <InputAHSF
          fieldsName="ApplicationNumberInput"
          show={true}
          disabled={true}
          // showValidationMessage={true}
          // validationMessage="يرجى تعبئة هذا الحقل"
          value={appInfo?.applicationNumber}
          showValidationMessage={false}
        />
        <InputAHSF
          fieldsName="ApplicationStatusInput"
          show={true}
          disabled={true}
          // showValidationMessage={true}
          // validationMessage="يرجى تعبئة هذا الحقل"
          value={appInfo?.sU_ST_MRI_ApplicationStatus?.statusName}
        />
        <InputAHSF
          fieldsName="RequestCreationDateInput"
          show={true}
          disabled={true}
          // showValidationMessage={true}
          // validationMessage="يرجى تعبئة هذا الحقل"
            value={moment(appInfo?.creationDate).format(
              "DD/MM/YYYY h:mm a"
            )}
        />
      </div>
    </>
  );
};

export default ApplicationInfo;
